import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { addMonths, format, startOfMonth } from "date-fns";
import { motion } from "framer-motion";
import "./Calendar.scss";
import { showAlertAutoClose } from "../services/notifyService";
import { DASHBOARD_URL } from "../api/AdminUrls";
import { post } from "../services/smartApiService";
import { useSiteContext } from "../contexts/SiteProvider";
import { SessionDetails } from "../pages";
import SessionDayReport from "../pages/sessions/SessionDayReport";

const CalendarView: React.FC = () => {
  const [monthOffset, setMonthOffset] = useState(0);
  const [events, setEvents] = useState<any>([]);
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [sessionData, setSessionData] = useState([]);
  const { openModal } = useSiteContext();

  // Calculate the selected start date (first day of the month)
  const start_date = format(
    startOfMonth(addMonths(new Date(), monthOffset)),
    "yyyy-MM-dd"
  );

  // console.log("Calendar",start_date)
   const colors = [
      { name: "WR", color: "#4BC0C0" },
      { name: "NCR", color: "#4BC0C0" },
      { name: "WCR", color: "#4BC0C0" },
      { name: "SCR", color: "#4BC0C0" },
      { name: "ER", color: "#4BC0C0" },
    ];
const loadTableData = () => {
  const URL = DASHBOARD_URL.DASHBOARD_GET_CALENDER;
  const subscription = post(URL, { start_date }).subscribe((response) => {
    const upcomingColor = "#5c61b2";   // Purple
    const completedColor = "#6dd5fa";  // Light Blue
    const todayColor = "#f4c430";      // Yellow (for current day)

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Clear time

    const mergedData = response.data.map((session: any) => {
      const sessionDate = new Date(session.session_date);
      sessionDate.setHours(0, 0, 0, 0); // Clear time

      let color = completedColor;
      if (sessionDate.getTime() === currentDate.getTime()) {
        color = todayColor; // If same as today
      } else if (sessionDate > currentDate) {
        color = upcomingColor;
      }

      return {
        ...session,
        color,
      };
    });

    setEvents(mergedData);
    console.log("Calendar Response", mergedData);
  });

  return () => {
    subscription.unsubscribe();
  };
};


  useEffect(() => {
    loadTableData();
  }, [start_date]);

  /** Filters events for the selected month */
  const getEventsForMonth = (monthOffset: number) => {
    const targetMonth = format(addMonths(new Date(), monthOffset), "yyyy-MM");
    return events.filter((event: any) =>
      event.session_date.startsWith(targetMonth)
    );
  };

  /** Handle date selection */
  // const handleDateClick = (date: Date) => {
  //   setSelectedDate(date);
  //   showAlertAutoClose(
  //     `Date selected: ${format(date, "yyyy-MM-dd")}`,
  //     "success"
  //   );
  // };

  const openDetails = (item: any) => {
    console.log("data input",item)
    let options = {
      title: "Sessions Details",
      content: <SessionDayReport date={item?.session_date}/>,
      className: "sd-efl-modal",
      closeBody: false,
      width: 90,
    };
    openModal(options);
  };

  return (
    <div className="container">
    <div className=" calendar-legend ">
  {/* <p className="title is-6">Calendar Legend</p> */}
  <div className="tags are-medium">
    <span className="tag" style={{ backgroundColor: "#6dd5fa", color: "#000" }}>
      ✅ Completed Session
    </span>
    <span className="tag" style={{ backgroundColor: "#f4c430", color: "#000" }}>
      📅 Today’s Session
    </span>
    <span className="tag" style={{ backgroundColor: "#5c61b2", color: "#fff" }}>
      ⏳ Upcoming Session
    </span>
  </div>
</div>

      <div className="calendar-controls m-3 is-flex is-justify-content-space-between">
        <div className="is-size-6 has-text-weight-bold"> Sessions Calender</div>
        <div>
          <button
            className="button is-small"
            onClick={() => setMonthOffset((prev) => prev - 1)}
          >
            <i className="fa fa-angle-left" aria-hidden="true"></i>
          </button>
          <span>{format(addMonths(new Date(), monthOffset), "MMMM yyyy")}</span>
          <button
            className="button is-small"
            onClick={() => setMonthOffset((prev) => prev + 1)}
          >
            <i className="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div className="columns">
        {[0, 1, 2].map((offset) => {
          const currentOffset = monthOffset + offset;
          const filteredEvents = getEventsForMonth(currentOffset);
          const month = addMonths(new Date(), currentOffset);
          const handleDateClick = (date: Date) => {
            const clickedEvent = filteredEvents.find(
              (event: any) => event.session_date === format(date, "yyyy-MM-dd")
            );

            if (clickedEvent) {
              openDetails(clickedEvent);
              // console.log("Event details:", clickedEvent);
            } else {
              console.log("No event on this date.");
            }
          };

          return (
            <motion.div
              key={currentOffset}
              className="column is-4 calendar-box"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: currentOffset * 0.2 }}
            >
              <h2 className=" is-5 has-text-weight-bold">
                {format(month, "MMMM yyyy")}
              </h2>
              <Calendar
                activeStartDate={month}
                value={selectedDate}
                showNavigation={false}
                onClickDay={handleDateClick}
                tileContent={({ date }) => {
                  console.log("selected",date)
                  const eventOnThisDay = filteredEvents.find(
                    (event: any) =>
                      event.session_date === format(date, "yyyy-MM-dd")
                  );
                  return eventOnThisDay ? (
                    <span
                      style={{
                        color: eventOnThisDay.color,
                        fontWeight: "bold",
                        backgroundColor: eventOnThisDay.color,
                        width: "25px",
                        height: "25px",
                        borderRadius: "50%",
                        padding: "3px 5px",
                        zIndex:"500"
                      }}
                    >
                     <span className="has-text-white">{format(date, "d")}</span> 
                    </span>
                  ) : null;
                }}
              />
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarView;
